<template>
  <kst-page-print-details page-footer
    v-slot="{ title }"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData" :customData="details"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column">
        <Details :data="details"/>
      </div>
      <div class="column">
        <Client :data="details"/>
      </div>
    </div>

    <Items class="block" :items="details.Items"/>
    <Total class="block" :data="details"/>
  </kst-page-print-details>
</template>

<script>
import Model from "../SlsModel.js";
import Services from "../../../services/Api/SalesServices.js";

import Details from "./SlsPD_Details.vue";
import Client from "./SlsPD_Client.vue";
import Items from "./SlsPD_Items.vue";
import Total from "./SlsPD_Total.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    Details,
    Client,
    Items,
    Total,
    Company
  },
  data: () => ({
    companyData: {},
    details: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadPrint) {
      this.resetData();

      const config = Services.getPrintDetailsData(id);
      loadPrint(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.details = data.Details;
      this.companyData = data.CompanyDetails;

      for (const item of this.details.Items) {
        Model.updateItemReadOnly(item);
      }
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.details = {};
    }
  }
}
</script>